/**
 * @generated SignedSource<<2cf2dfd973cc223a8265757fa6e69c2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateInstructionGenerationRequestInput = {
  generationInput?: any | null | undefined;
  instructionType: string;
  resources?: ReadonlyArray<ResourceToIngest>;
  teamId?: any | null | undefined;
};
export type ResourceToIngest = {
  inputJson?: string | null | undefined;
  onboardingType: string;
};
export type CreateInstructionGenerationRequestMutation$variables = {
  input: CreateInstructionGenerationRequestInput;
};
export type CreateInstructionGenerationRequestMutation$data = {
  readonly createInstructionGenerationRequest: {
    readonly error: string | null | undefined;
    readonly generationRequestId: number | null | undefined;
    readonly success: boolean;
  };
};
export type CreateInstructionGenerationRequestMutation = {
  response: CreateInstructionGenerationRequestMutation$data;
  variables: CreateInstructionGenerationRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateInstructionGenerationRequestPayload",
    "kind": "LinkedField",
    "name": "createInstructionGenerationRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "generationRequestId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateInstructionGenerationRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateInstructionGenerationRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e0a87d4eeba18e59cdc362ccee8f17c0",
    "id": null,
    "metadata": {},
    "name": "CreateInstructionGenerationRequestMutation",
    "operationKind": "mutation",
    "text": "mutation CreateInstructionGenerationRequestMutation(\n  $input: CreateInstructionGenerationRequestInput!\n) {\n  createInstructionGenerationRequest(input: $input) {\n    success\n    error\n    generationRequestId\n  }\n}\n"
  }
};
})();

(node as any).hash = "a476b1320f482a577c5557e019e391f3";

export default node;
